import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../app/appTypes";
import { getWithAuth } from "../../http";

export interface UrsRequestMatchingHistory {
    id: number;
    batchId: string;
    sourceUrsOfferId: number;
    sourceUrsId: number;
    sourceUrsNumber: string;
    matchedUrsId: number;
    matchedUrsNumber: string;
    sourceRequirementId: number;
    matchedRequirementId: number;
    sourceText: string;
    matchedText: string;
    comment: string;
    note: string;
    levenshteinSimilarity: number;
    sbertSimilarity: number;
}


export const loadHistoryForBatch = createAsyncThunk<
    UrsRequestMatchingHistory[], { batchId: string }, AppThunkAPIType>(
        "matching-results/get-for-batch",
        async ({ batchId }, { dispatch, rejectWithValue }) => {

            const result = await dispatch(
                getWithAuth({ url: `api/UrsOffers/matching-results/${batchId}` })
            );

            const { payload } = result;

            if (getWithAuth.fulfilled.match(result)) {
                return payload as UrsRequestMatchingHistory[] || [];
            } else {
                return rejectWithValue(payload ?? { kind: "unknown" });
            }
        }
    );
